import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Section } from '../../models/section';
import { Person } from '../../models/person';
import { I_competition_entry } from '../../models/i_competition_entry.interface';
import { faCheck, faTrash, faTimes } from '@fortawesome/fontawesome-pro-regular';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-modal-choose-section',
  templateUrl: './modal-choose-section.component.html',
  styleUrls: ['./modal-choose-section.component.css']
})
export class ModalChooseSectionComponent extends SmsAbstractAppPage implements OnInit {

  faCheck = faCheck;
  faTrash = faTrash;
  faTimes = faTimes;

  @Input() section_list: Section[];
  @Input() riders: Person[] = [];
  @Input() selected_rider: Person;
  @Input() pending_competition_entry_list: I_competition_entry[] = [];

  entire_section_list: Section[];
  filter_text: string = '';

  @Output() section_selected$: EventEmitter<Section> = new EventEmitter<Section>();
  @Output() section_removed$: EventEmitter<Section> = new EventEmitter<Section>();

  public selected_section_map: Map<string, Section> = new Map<string, Section>();

  constructor(public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit() {
    this.entire_section_list = this.section_list;

    // Pre-populate from sections already on the entry
    this.pending_competition_entry_list
      .filter(e => e.is_section_entry)
      .forEach(e => {
        const section = this.entire_section_list.find(s => s.id === e.section_id);
        if (section) this.selected_section_map.set(section.id, section);
      });
  }

  get total_count(): number {
    return this.entire_section_list?.length ?? 0;
  }

  get selected_count(): number {
    return this.selected_section_map.size;
  }

  handleSelectSection(section: Section) {
    this.selected_section_map.set(section.id, section);
    this.section_selected$.emit(section);
  }

  handleUnSelectSection(section: Section) {
    this.selected_section_map.delete(section.id);
    this.section_removed$.emit(section);
  }

  toggleSection(section: Section) {
    if (this.selected_section_map.has(section.id)) {
      this.handleUnSelectSection(section);
    } else {
      this.handleSelectSection(section);
    }
  }

  handleFilterSections(filterText: string) {
    this.filter_text = filterText;

    if (!filterText) {
      this.section_list = this.entire_section_list;
      return;
    }

    const term = filterText.toLowerCase();
    const seen = new Set<string>();
    const result: Section[] = [];

    // First pass: name starts-with (highest relevance)
    this.entire_section_list.forEach(section => {
      if (section.name.toLowerCase().startsWith(term) && !seen.has(section.id)) {
        result.push(section);
        seen.add(section.id);
      }
    });

    // Second pass: name contains or number matches
    this.entire_section_list.forEach(section => {
      const matchesName = section.name.toLowerCase().includes(term);
      const matchesNumber = String(section.number).includes(term);
      if ((matchesName || matchesNumber) && !seen.has(section.id)) {
        result.push(section);
        seen.add(section.id);
      }
    });

    this.section_list = result;
  }

  clearFilter() {
    this.filter_text = '';
    this.section_list = this.entire_section_list;
  }

  // Select the first visible result on Enter from the filter input
  handleEnterKey() {
    if (this.section_list.length > 0 && !this.selected_section_map.has(this.section_list[0].id)) {
      this.handleSelectSection(this.section_list[0]);
    }
  }
}
